import OllieLayout from "components/layouts/ollie-layout/ollie-layout";
import OllieChat from "components/ollie-chat/ollie-chat";

// The same conversation the floating panel holds, given the whole page. There is nothing to put
// away here, so the chat is drawn without a close control.
//
// The only /ollie screen that describes nothing to Ollie: what the reader has open IS the
// conversation, and telling Ollie that would say nothing it does not already know.
const OllieChatPage = () => {
	return (
		<OllieLayout>
			<div className="icp-page">
				<div className="icp-chat">
					<OllieChat />
				</div>
			</div>
		</OllieLayout>
	);
};

export default OllieChatPage;
